export const FETCH_REDEMPTION = 'redemption/FETCH';
export const FETCH_REDEMPTION_SUCCESS = 'redemption/FETCH_SUCCESS';
export const FETCH_REDEMPTION_FAIL = 'redemption/FETCH_FAIL';

/* eslint-disable */
const ViewRedemptionReducer = (state = {
}, action = {}) => {
  switch (action.type) {
    case FETCH_REDEMPTION:

      if (action.redemptionId) {
        return state[action.redemptionId];
      }
      return {
        data: {},
        isLoading: true,
        error: false
      };
    case FETCH_REDEMPTION_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false
      };
    case FETCH_REDEMPTION_FAIL:
      return {
        data: {},
        isLoading: false,
        error: true
      };
    default:
      return { ...state };
  }
};

export default ViewRedemptionReducer;